import script from "./FastSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./FastSearch.vue?vue&type=script&setup=true&lang=js"

import "./FastSearch.vue?vue&type=style&index=0&id=e67e03cc&lang=scss"

const __exports__ = script;

export default __exports__